export const shadows = {
  primary: '0px 8px 38px 0px rgba(0, 0, 0, 0.12)',
  secondary: ' 0px 8px 38px 0px rgba(0, 0, 0, 0.05)',
  tertiary: '0px 8px 38px 0px rgba(0, 0, 0, 0.12)',
}
